import mixpanel from "mixpanel-browser";
import trackDolosMixpanelRequest from "lib/requests/dolos";

const { REACT_APP_MIXPANEL_API_KEY } = process.env;

mixpanel.init(REACT_APP_MIXPANEL_API_KEY);
let defaultProps = {};

export const mixpanelBase = (bodyMixpanelProps) => {
  defaultProps = { ...defaultProps, ...bodyMixpanelProps };
};

const mixpanelTrack = (eventName, eventProperties = {}) => {
  const eventMixpanel = {
    event: {
      name: eventName,
      event_properties: eventProperties,
    },
  };
  defaultProps = { ...defaultProps };
  defaultProps.properties = { ...defaultProps.properties, ...eventMixpanel };
  trackDolosMixpanelRequest(defaultProps);
};

export default mixpanelTrack;
